export const pendingSurveysSelector = state => state.pendingSurveys;
